import * as coreEntities from '_core/store/index';
import { CLIENT } from '_core/variables/constant';
import { useSelector } from 'react-redux';

export function useOrganization() {
  const client = useSelector((state) => coreEntities.organization.selectors.getClient(state));
  const tenantData = useSelector((state) => coreEntities.organization.selectors.getTenant(state));
  const featureFlags = useSelector((state) => coreEntities.organization.selectors.getFeatureFlags(state));
  const canCreateGroup = useSelector((state) => coreEntities.organization.selectors.getCanCreateGroup(state));
  const canCreateCourse = useSelector((state) => coreEntities.organization.selectors.getCanCreateCourse(state));

  const canChangeAvatar =
    client !== CLIENT.SANTILLANA_PILOTO &&
    client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
    client !== CLIENT.SANTILLANA_INTEGRATIONS &&
    client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
    client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  const hasSupport =
    client !== CLIENT.SANTILLANA_PILOTO &&
    client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
    client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
    client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  const showAccountTab =
    client !== CLIENT.SANTILLANA_PILOTO &&
    client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
    client !== CLIENT.SANTILLANA_INTEGRATIONS &&
    client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
    client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  const showDisregardedPrograms =
    client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO && client !== CLIENT.SANTILLANA_INTEGRATIONS;
  const showKidsMode = client === CLIENT.SANTILLANA_PILOTO;
  const canEditProfileInfo =
    client !== CLIENT.SANTILLANA_PILOTO &&
    client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
    client !== CLIENT.SANTILLANA_INTEGRATIONS &&
    client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
    client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  const canEditCourse =
    client !== CLIENT.SANTILLANA_PILOTO &&
    client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
    client !== CLIENT.SANTILLANA_INTEGRATIONS &&
    client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
    client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;

  const logoutRedirect =
    client === CLIENT.SANTILLANA_PILOTO ||
    client === CLIENT.SANTILLANA_INTEGRATIONS ||
    client === CLIENT.SANTILLANA_ALFA ||
    client === CLIENT.EDELVIVES ||
    client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const hideLibrary = client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_COLOMBIA_DEMO || client === CLIENT.SANTILLANA_INTEGRATIONS;
  const hideTeacher = client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_COLOMBIA_DEMO || client === CLIENT.SANTILLANA_INTEGRATIONS;
  const hideEducationLevelGroup =
    client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_INTEGRATIONS || client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  const newProgramInterface =
    client === CLIENT.TANGERINE ||
    client === CLIENT.SANTILLANA_BRASIL_DEMO ||
    client === CLIENT.SANTILLANA_BRASIL_COMPARTILHA ||
    client === CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM ||
    client === CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;

  return {
    client,
    tenantConfig: {
      ...tenantData,
      ...featureFlags,
      hideTeacher: hideTeacher,
      showLogout: true,
      canChangeAvatar: canChangeAvatar,
      hasSupport: hasSupport,
      showAccountTab: showAccountTab,
      canCreateGroup: canCreateGroup,
      canCreateCourse: canCreateCourse,
      showDisregardedPrograms: showDisregardedPrograms,
      showKidsMode: showKidsMode,
      hideLibrary: hideLibrary,
      hideEducationLevelGroup: hideEducationLevelGroup,
      canEditProfileInfo: canEditProfileInfo,
      canEditCourse: canEditCourse,
      logoutRedirect: logoutRedirect,
      newProgramInterface: newProgramInterface,
    },
  };
}
